var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76326 4.9268C1.54119 3.37228 3.11516 2.17992 4.55149 2.81458L22.3324 10.6712C23.9213 11.3733 23.9213 13.6279 22.3324 14.33L4.55149 22.1866C3.11516 22.8213 1.54119 21.6289 1.76326 20.0744L2.48928 14.9923C2.55828 14.5093 2.91284 14.1162 3.38617 13.9978L9.37514 12.5006L3.38617 11.0034C2.91284 10.885 2.55828 10.4919 2.48928 10.0089L1.76326 4.9268ZM21.524 12.5006L3.74316 4.64396L4.3931 9.19355L13.3528 11.4334C14.4637 11.7112 14.4637 13.29 13.3528 13.5678L4.3931 15.8077L3.74316 20.3572L21.524 12.5006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.489e30a25f2a6cf2e6b15a8053dd77ad.svg";
export { ForwardRef as ReactComponent };